export default function CompanySection() {
  return (
    <section
      id="company"
      className="relative min-h-screen flex items-center overflow-hidden"
    >
      {/* Background image */}
      <img
        src="https://public.readdy.ai/ai/img_res/d8a724fc97e180b73a15338feb6149f5.jpg"
        alt="Hero background"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#0d1a2a]/80 via-[#1A2332]/70 to-[#0d1a2a]/80" />

      <div className="relative z-10 w-full max-w-6xl mx-auto px-6 md:px-10 py-32">
        <div className="max-w-2xl">
          <p className="text-xs uppercase tracking-[3px] text-white/50 mb-6 font-medium">
            iOS App Development
          </p>
          <h1 className="text-5xl md:text-7xl font-extrabold text-white leading-tight mb-6">
            Modern iOS<br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#5ee7d0] to-[#a8edea]">
              Applications
            </span>
          </h1>
          <p className="text-lg md:text-xl text-white/70 leading-relaxed max-w-xl">
            BLANO DOO is a team of experts developing modern applications for the iOS platform.
            Our products are designed to enhance user experience and improve the security of mobile devices.
          </p>

          <div className="mt-14 flex flex-wrap gap-10">
            <div>
              <p className="text-4xl font-extrabold text-white">100%</p>
              <p className="text-sm text-white/50 mt-1 tracking-wide">Security Focused</p>
            </div>
            <div>
              <p className="text-4xl font-extrabold text-white">Expert</p>
              <p className="text-sm text-white/50 mt-1 tracking-wide">Development Team</p>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 text-white/40">
        <span className="text-xs tracking-widest uppercase">Scroll</span>
        <i className="ri-arrow-down-line text-lg animate-bounce" />
      </div>
    </section>
  );
}
